/* eslint no-use-before-define: "error"*/
import React, {
    useState, useContext, useCallback, useEffect
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import {
    ViewModelServiceContext,
    withViewModelService,
    ViewModelForm
} from '@xengage/gw-portals-viewmodel-react';
import { MLTransactionDiffService } from 'gw-capability-gateway';
import { MLTooltipComponent } from 'ml-components-platform-react';
import { useTranslator } from '@jutro/locale';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import { MLTagManagerService } from 'ml-portals-services-react'
import MLTransactionDiffPopup from '../../Policies/MLSummary/MLTransactionDiff/MLTransactionDiffPopup'
import MLTransactionDiffListPopup from '../../Policies/MLSummary/MLTransactionDiff/MLTransactionDiffListPopup'
import metadata from './MLCompletedTransactionsComponent.metadata.json5';
import messages from './MLCompletedTransactionsComponent.messages';
import styles from './MLCompletedTransactionsComponent.module.scss';
import { Button } from '@jutro/legacy/components';

import { IntlContext } from '@jutro/legacy/locale';

const MLCompletedTransactionsComponent = (props) => {
    const {
        authHeader,
        policyNumber
    } = props;
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const [transactionsSubmissionVM, updateTransactionsSubmissionVM] = useState({});
    const [completedTransactions, setCompletedTransactions] = useState([]);
    const { onValidate } = useValidation('MLCompletedTransactionsComponent');
    const [isComparisonPopupOpen, setIsComparisonPopupOpen] = useState(false);
    const [isSecondComparisonPopupOpen, setIsSecondComparisonPopupOpen] = useState(false);
    const [transactionDiffTree, setTransactionDiffTree] = useState({});
    const [transactionDiffData, setTransactionDiffData] = useState({});

    const writeValue = useCallback(
        (value, path) => {
            const newTransactionsSubmissionVM = viewModelService.clone(transactionsSubmissionVM);
            _.set(newTransactionsSubmissionVM, path, value);
            updateTransactionsSubmissionVM(newTransactionsSubmissionVM);
        },
        [transactionsSubmissionVM, viewModelService]
    );

    const getTransactions = async () => {
        const transactions = await MLTransactionDiffService.getTransactions(policyNumber, authHeader);
        setCompletedTransactions(transactions);
    };

    useEffect(() => {
        getTransactions();
        const diffData = {
            transaction1: undefined,
            transaction2: undefined,
            transactionList1: [],
            transactionList2: []
        };
        setTransactionDiffData(diffData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    

    const getTransactionDiffListPopup = () => {
        MLTagManagerService.sendFormStartEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Compare Term`);
        const componentProps = {
            transactions: transactionDiffTree.jobTransactions,
            diff: transactionDiffTree.diffNodes,
            isOpen: isSecondComparisonPopupOpen,
            onReject: () => setIsSecondComparisonPopupOpen(false),
        };
        return <MLTransactionDiffListPopup {...componentProps} />;

    }

    const getTransactionDiffPopup = () => {

        const getDiff = (data) => {
            // check dates to make sure the earlier effective date shows on the left side of the comparison modal
            if (MLLocalDateUtil.localDate2Date(data.transaction1.effDate) < MLLocalDateUtil.localDate2Date(data.transaction2.effDate)) {
                return MLTransactionDiffService.getDiffBetweenJobs(data.transaction2.jobNumber, data.transaction1.jobNumber, policyNumber, authHeader);
            }
            return MLTransactionDiffService.getDiffBetweenJobs(data.transaction1.jobNumber, data.transaction2.jobNumber, policyNumber, authHeader);
        };

        const onClickDiffButton = async (data) => {
            MLTagManagerService.sendFormStartEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Compare Term`);
            const diff = await getDiff(data);
            setTransactionDiffTree(diff);
            setIsComparisonPopupOpen(false);
            setIsSecondComparisonPopupOpen(true);
        };

        if (isComparisonPopupOpen) {
            const componentProps = {
                data: transactionDiffData,
                policyNumber: policyNumber,
                onSaveAction: (data) => onClickDiffButton(data),
                isOpen: isComparisonPopupOpen,
                onReject: () => setIsComparisonPopupOpen(false),
                onResolve: () => setIsComparisonPopupOpen(false)
            };
            return <MLTransactionDiffPopup {...componentProps} />;
        };
        return null;
    };


    const getInitiator = (transaction) => {
        if (transaction.initiator) {
            return transaction.initiator;
        }
        if (transaction.createUserName === 'Portal User') {
            return translator(messages.insured);
        }
        if (transaction.createUserType === 'other') {
            return transaction.createUserType;
        }
        return translator(messages.agent);
    };


    const compareTerms = (index) => {
        MLTransactionDiffService.getDiffBetweenJobs(completedTransactions[index].jobNumber, completedTransactions[index + 1].jobNumber, policyNumber, authHeader).then((diff) => {
            setTransactionDiffTree(diff);
            setIsSecondComparisonPopupOpen(true);
        });
    };

    const getCompareValue = (transaction) => {
        return (
            <Button onClick={() => compareTerms(transaction)} className={styles.noTextTransform} type="text">{translator(messages.compare)}</Button>
        )
    };

    const getFormatCurrency = (value) => {
        let formattedAmount = '';
        if (value) {
            const { amount, currency } = value;
            if (!_.isUndefined(amount) && currency) {
                formattedAmount = intl.formatNumber(
                    amount,
                    {
                        style: 'currency',
                        currency: currency
                    }
                );
            }
        }
        return formattedAmount;
    };

    const getDateString = (date) => {
        return `${date.month+1}/${date.day}/${date.year}`;
    }

    const onClickCompare = () => {
        const newData = transactionDiffData;
        if (transactionDiffData.transactionList1.length === 0) {
            completedTransactions.forEach((t) => {
                t.name = `${t.jobType} ${getDateString(t.effDate)}`;
            });
            newData.transactionList1 = completedTransactions;
            newData.transaction1 = transactionDiffData.transactionList1.find((t) => t.current === true);
            newData.transactionList2 = transactionDiffData.transactionList1.filter((t) => t !== newData.transaction1);
        };
        setIsComparisonPopupOpen(true) 
        setTransactionDiffData(newData)
    };

    const generateTransactionsListOverrides = () => {
        const overrides = completedTransactions.map((transaction, index) => {
            return {
                [`dateRow${index}`]: {
                    content: moment(transaction.effDate).format('MM/DD/YYYY')
                },
                [`premiumRow${index}`]: {
                    content: (_.isUndefined(transaction.transactionCost) || transaction.transactionCost.amount === 0) ? translator(messages.dash) : getFormatCurrency(transaction.transactionCost) 
                },
                [`descriptionRow${index}`]: {
                    content: transaction.jobType
                },
                [`initiatorRow${index}`]: {
                    content: _.capitalize(getInitiator(transaction))
                },
                [`compareRow${index}`]: {
                    content: index !== completedTransactions.length - 1 && getCompareValue(index)
                }
            };
        });

        return Object.assign({}, ...overrides);
    };


    const overrideProps = {
        transactionsTableRowIterable: {
            data: completedTransactions
        },
        detailsHeader: {
            content: (
                <div className={styles.detailsBlock}>
                    {translator(messages.details)}
                    <MLTooltipComponent
                        noWrapper
                        tooltipHeader={translator(messages.detailsLabel)}
                        tooltipContent={translator(messages.detailsHelpMsg)}
                    />
                </div>
            )
        },

        ...generateTransactionsListOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onClickCompare: onClickCompare,
        }
    };
    const readValue = (id, path) => {
        return readViewModelValue(
            metadata.componentContent,
            transactionsSubmissionVM,
            id,
            path,
            overrideProps
        );
    };
    return (
        <>
            { isComparisonPopupOpen && getTransactionDiffPopup()}
            { isSecondComparisonPopupOpen && getTransactionDiffListPopup()}
            <ViewModelForm
                uiProps={metadata.componentContent}
                overrideProps={overrideProps}
                model={transactionsSubmissionVM}
                onValueChange={writeValue}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                resolveValue={readValue}
                onValidationChange={onValidate}
            />
        </>
    );
};

MLCompletedTransactionsComponent.propTypes = {
    authHeader: PropTypes.shape({
        Authorization: PropTypes.string
    }).isRequired,
    policyNumber: PropTypes.string,
};
export default withRouter(withViewModelService(MLCompletedTransactionsComponent));
